import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/salary/payroll";
const apiSalarySlipEndpoint = API_BASE_URL_ENV() + "/admin/salary/slip";

export default class SalariesService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getSalarySlip(params) {
		return http.get(`${apiSalarySlipEndpoint}`, { params });
	}

	getPayrollDetails(employeeId, params) {
		return http.get(`${apiEndpoint}/${employeeId}`, { params });
	}
}
